export default {


  emailRules: [
    v => !!v || "Поле Емейл обязательно",
    v => /.+@.+\..+/.test(v) || "Некорректный емейл"
  ],
  emptyRules: [v => !!v || "Поле обязательно для заполнения"],
  nameRules: [
    v => !!v || "Поле обязательно для заполнения",
    v => (v && v.length >= 2) || "поле должно быть не менее 2 символов"
  ],
  innRulesJL: [
    v => !!v || "Это поле обязательно для заполнения",
    v => (v && v.length == 10) || "ИНН должен быть 10 символов"
  ],
  phoneRules: [
    v => !!v || "Это поле обязательно для заполнения",
    v => (v && v.length == 14) || "Должно быть введено 10 цифр"
  ],
  innRulesIP: [
    v => !!v || "Это поле обязательно для заполнения",
    v => (v && v.length == 12) || "ИНН должен быть 12 символов"
  ],
  innRulesFL: [
    v => !!v || "Это поле обязательно для заполнения",
    v => (v && v.length == 12) || "ИНН должен быть 12 символов"
  ],
  snilsRules: [
    v => !!v || "Это поле обязательно для заполнения",
    v => (v && v.length == 11) || "СНИЛС должен быть 11 символов"
  ],
  passwordRules: [
    v => !!v || "Это поле обязательно для заполнения",
    v =>
      (v && v.length <= 16 && v.length >= 6) ||
      "Пароль должен быть от 6 до 16 символов"
  ],
  innRules: [
    v => !!v || "Это поле обязательно для заполнения",
    v =>
      (v && (v.length == 10 || v.length == 12)) ||
      "ИНН должен быть 10 или 12 символов"
  ],
  orgRuleRequired: [
    v => !!v || "Это поле обязательно для заполнения",
    v => (v && v.length >= 2) || "Поле должно быть не менее 2 символов"
  ],
  orgRule: [
    v => (v && v.length >= 2) || "Поле должно быть не менее 2 символов"
  ],

  bankAccount: [
    v => !!v || "Это поле обязательно для заполнения",
    v => (v && v.length == 20) || "Поле должно быть 20 символов"
  ],
  
  bik: [
    v => !!v || "Это поле обязательно для заполнения",
    v => (v && v.length >= 9) || "Поле должно не менее 9 символов"
  ],

  purchase_number_rules: [v => !!v || "Это поле обязательно для заполнения"],
  inn10mask: "##########",
  inn12mask: "############",
  phonemask: "(###)### ## ##",
  dateMask: "##.##.####",
  nomerzak: "###################"
};
